import Bugsnag from "@bugsnag/js";
import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import ErrorComponent from "../ErrorComponent/ErrorComponent";

/**
 * Router error element. Without one, an error thrown by a loader or route component
 * renders React Router's default page, which shows the raw stack trace to the user.
 * Route errors never reach the Bugsnag error boundary, so report them here.
 */
const RouteErrorPage = () => {
  const error = useRouteError();

  useEffect(() => {
    console.error("Route error:", error);
    if (error instanceof Error && Bugsnag.isStarted()) {
      Bugsnag.notify(error);
    }
  }, [error]);

  return <ErrorComponent />;
};

export default RouteErrorPage;
